import React, { Component, Fragment } from "react";

// Libs
import { Link } from "react-router-dom";

// MUI
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

// Consts
const HomeLink = props => <Link to="/" {...props} />;
const styles_LogoutPanel = {
  padding: "20px",
  maxWidth: "400px",
  margin: "100px auto 0",
  textAlign: "center"
};

class Logout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      test: ""
    };
  }

  componentDidMount() {
    // this.props.logout();
  }

  render() {
    return (
      <Paper elevation={4} style={styles_LogoutPanel}>
        <Typography component="p" style={{ margin: "20px 0" }}>
          You're logged out
        </Typography>
        <Button
          variant="raised"
          size="large"
          color="primary"
          className="logout"
          component={HomeLink}
        >
          Home
        </Button>
      </Paper>
    );
  }
}

export default Logout;
